/* =========================================================
   JSM — Sélecteur de langue « A2 Bulle »
   Ouvre / ferme la bulle. Le changement de langue est fait par
   le formulaire de localisation natif Shopify (boutons submit).
   ========================================================= */
(() => {
  if (customElements.get('jsm-langue-bulle')) return;

  class JsmLangueBulle extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.jsm-lb__trigger');
      this.bubble = this.querySelector('.jsm-lb__bubble');
      this.form = this.querySelector('form');
      if (!this.trigger || !this.bubble) return;

      this.onDocPointer = this.onDocPointer.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);

      this.trigger.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-jsm-lb-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.close(true))
      );
      if (this.form) {
        this.form.addEventListener('submit', () => this.setAttribute('data-loading', ''));
      }
    }

    disconnectedCallback() {
      this.removeListeners();
    }

    open() {
      if (this.hasAttribute('data-open')) return;
      this.bubble.hidden = false;
      this.setAttribute('data-open', '');
      this.trigger.setAttribute('aria-expanded', 'true');

      document.addEventListener('pointerdown', this.onDocPointer);
      document.addEventListener('keydown', this.onKey);
      this.addEventListener('focusout', this.onFocusOut);

      const first = this.bubble.querySelector('.jsm-lb__item');
      requestAnimationFrame(() => first && first.focus({ preventScroll: true }));
    }

    close(returnFocus) {
      if (!this.hasAttribute('data-open')) return;
      this.bubble.hidden = true;
      this.removeAttribute('data-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.removeListeners();
      if (returnFocus) this.trigger.focus({ preventScroll: true });
    }

    removeListeners() {
      document.removeEventListener('pointerdown', this.onDocPointer);
      document.removeEventListener('keydown', this.onKey);
      this.removeEventListener('focusout', this.onFocusOut);
    }

    onDocPointer(event) {
      if (!this.contains(event.target)) this.close(false);
    }

    onKey(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.close(true);
      }
    }

    onFocusOut(event) {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
    }
  }

  customElements.define('jsm-langue-bulle', JsmLangueBulle);
})();